export const COGNITO = {
  development: {
    USER_POOL_ID: "us-east-1_8SnEZOAgB",
    CLIENT_ID: "64ofj639hrcklk4kobfsq662r2",
    APP_DOMAIN: "onegate-preprod.auth.us-east-1.amazoncognito.com",
    REDIRECT_URL: "http://localhost:3000/auth/social/google",
    LOGOUT_URL: "http://localhost:3000/auth",
  },
  preproduction: {
    USER_POOL_ID: "us-east-1_8SnEZOAgB",
    CLIENT_ID: "64ofj639hrcklk4kobfsq662r2",
    APP_DOMAIN: "onegate-preprod.auth.us-east-1.amazoncognito.com",
    REDIRECT_URL: "https://workspace-preprod.onegate.ai/auth/social/google",
    LOGOUT_URL: "https://workspace-preprod.onegate.ai/auth",
  },
  production: {
    USER_POOL_ID: "us-east-1_lNeXvj8ib",
    CLIENT_ID: "2k1ps1a44ku47eddir9v1b4bjv",
    APP_DOMAIN: "auth.onegate.ai",
    REDIRECT_URL: "https://workspace.onegate.ai/auth/social/google",
    LOGOUT_URL: "https://workspace.onegate.ai/auth",
  },
};
